import {
	createHook,
	createStore,
	type BoundActions,
	type HookFunction,
	type StoreActionApi,
} from 'react-sweet-state';

import { getCloudIdAsync } from '../../services/tenant-info-provider';

type State = {
	// We want `cloudId` is always a string and empty value as default value. That helps to avoid dealing with null/undefined hassle.
	cloudId: string;
	isLoading: boolean;
	hasLoaded: boolean;
};
type StoreApi = StoreActionApi<State>;

const actions = {
	getCloudId:
		() =>
		async ({ setState, getState }: StoreApi): Promise<void> => {
			if (getState().isLoading) {
				return;
			}

			setState({
				isLoading: true,
			});

			try {
				const cloudId = await getCloudIdAsync();
				setState({
					cloudId: cloudId || '',
				});
			} catch (e) {
				// ignore error for now.
			} finally {
				setState({
					isLoading: false,
					hasLoaded: true,
				});
			}
		},

	// This action is used by EmbeddedDirectory to get Cloud Id in a remote store.
	setCloudId:
		(cloudId: string) =>
		({ setState }: StoreApi): void => {
			setState({
				cloudId,
				isLoading: false,
			});
		},
};
type Actions = typeof actions;

const initialState: State = {
	cloudId: '',
	isLoading: false,
	hasLoaded: false,
};

/**
 * Manage states of a site
 */
const Store = createStore<State, Actions>({
	initialState,
	actions,
	name: 'Site',
});

export const useSiteStandaloneApp: HookFunction<
	State,
	BoundActions<
		State,
		{
			getCloudId: () => ({ setState, getState }: StoreApi) => Promise<void>;
			// This action is used by EmbeddedDirectory to get Cloud Id in a remote store.
			setCloudId: (cloudId: string) => ({ setState }: StoreApi) => void;
		}
	>,
	void
> = createHook(Store);
